import { Messages } from '../const';
export default {
    [Messages.METRICS_MISSED]: 'Метрика "{name}" отсутствует в схеме источника',
    [Messages.DIMENSIONS_MISSED]: 'Измерение "{name}" отсутствует в схеме источника',
    [Messages.VARIABLES_MISSED]: 'Переменная "{name}" отсутствует в схеме источника',
    [Messages.DRILLDOWN_DIMENSIONS_MISSED]: 'Измерение "{dimensions}" сложного измерения "{name}" отсутствует в схеме источника',

    [Messages.QUERY_DIMENSION_MISSED]: 'Измерение "{name}" отсутствует в схеме запроса',
    [Messages.DRILLDOWN_MISSED_QUERY_DIMENSIONS]: `Сложное измерение "{name}" содержит измерение "{dimensions}" отсутствующее в схеме запроса`,
    [Messages.DRILLDOWN_CONFLICTING_QUERY_PARAM]: `Сложноt измерения "{name}" совпадает с названием одного из показателей схемы запроса`,
    [Messages.SORT_MISSED_QUERY_PARAM]: `Сортировка "{name}" использует показатель отсутствующий в схеме запроса`,
    [Messages.FILTER_MISSED_QUERY_PARAM]: `Фильтр "{name}" использует показатель отсутствующий в схеме запроса`,

    [Messages.DATASET_NOT_FOUND_IN_DATA_PROVIDER]: `Датасет отсутствует в выбранном провайдере данных`,
    [Messages.DATASET_DATAPROVIDER_NOT_EXISTS_IN_PROJECT]: `Указанный в датасете провайдер данных не существует в проекте`
};